webpackJsonp([29],{

/***/ 1285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HubspotChat_vue__ = __webpack_require__(2614);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e33ba39_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HubspotChat_vue__ = __webpack_require__(2682);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2680)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HubspotChat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e33ba39_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HubspotChat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/public/HubspotChat.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3e33ba39", Component.options)
  } else {
    hotAPI.reload("data-v-3e33ba39", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_vendorKeys__ = __webpack_require__(1287);

//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    loadScriptAsync: function loadScriptAsync(id) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!document.getElementById(id)) {
          var tag = document.createElement('script');
          tag.text = 'var _smartsupp = _smartsupp || {}; _smartsupp.key = \'' + __WEBPACK_IMPORTED_MODULE_1__constants_vendorKeys__["c" /* getSmartsuppKey */] + '\';          window.smartsupp||(function(d) {            var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];            s=d.getElementsByTagName(\'script\')[0];c=d.createElement(\'script\');            c.type=\'text/javascript\';c.charset=\'utf-8\';c.async=true;            c.src=\'https://www.smartsuppchat.com/loader.js?\';s.parentNode.insertBefore(c,s);          })(document);';
          /* tag.src = uri */
          tag.type = 'text/javascript';
          /* tag.async = true
          tag.defer = true */
          tag.setAttribute('id', id);
          tag.onload = function () {
            resolve();
          };
          document.head.appendChild(tag);
        } else {
          resolve();
        }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    // const _this = this
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
    this.loadScriptAsync('smartsupp-script-loader').then(function () {
      _this.loading = false;
      var chatBtn = null;
      setTimeout(function () {
        chatBtn = document.getElementById('chat-application');
        if (chatBtn) {
          chatBtn.click();
        }
      }, 2000);
    });
  },
  created: function created() {
    /* window.hsConversationsSettings = {
      loadImmediately: true,
      inlineEmbedSelector: '#support-chat-container',
      enableWidgetCookieBanner: false,
      disableAttachment: false
    } */
  }
});

/***/ }),

/***/ 2680:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2681);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("cbba1dec", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3e33ba39\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HubspotChat.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3e33ba39\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HubspotChat.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2681:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n#hubspot-conversations-inline-iframe {\n  height: calc(var(--vh, 1vh) * 100) !important;\n  height: 100vh;\n  width: 100%;\n  border: 0px;\n}\n", ""]);

// exports


/***/ }),

/***/ 2682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "support-chat-container" } })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e33ba39", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/29.bb10e8ac4d4b2c9331d7.js